var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('files-selector',{attrs:{"uploading":_vm.uploading},on:{"upload":_vm.onUpload},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82a58ea6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/UserPrivateFilesUploader.vue
// module id = null
// module chunks = 